module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/bg-6-9ebaccb57c3b0b2e19aea2f4adf2ea01.png";